import React from "react";
import Well1Logo from "../../assets/svg/well-1-img.svg";
import Well2Logo from "../../assets/svg/well-2-img.svg";
import Well3Logo from "../../assets/svg/well-3-img.svg";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../store/store";
import { handleSOSUpdate } from "../../store/reducers/authentication/apiThunk";
import { showToast } from "../../components/Toast";
const ChooseBenefits = ({ selectData, isdisabled }: any) => {
  const dispatch = useDispatch<AppDispatch>();

  const arr = [
    {
      id: 1,
      img: Well1Logo,
      name: "Doctor on call",
    },
    {
      id: 2,
      img: Well2Logo,
      name: "Nutrition Coaching",
    },
    {
      id: 3,
      img: Well3Logo,
      name: "Dental Checkup",
    },
    {
      id: 4,
      img: Well1Logo,
      name: "Lab Tests",
    },
    {
      id: 5,
      img: Well2Logo,
      name: "Pharmacy",
    },
    {
      id: 6,
      img: Well3Logo,
      name: "Other Discounts",
    },
  ];

  const handleClick = async () => {
    if (selectData?.livLongTransactionID) {
      const data = {
        prosureCustomerId: selectData?.prosureCustomerId,
        vdf1: selectData?.livLongTransactionID,
      };
      try {
        const res = await dispatch(handleSOSUpdate(data)).unwrap(); // Unwraps to return raw result or throw error
        console.log("handleSOSUpdate", res);
        if (res?.status === 1) {
          window.open(res?.data, '_blank', 'noopener,noreferrer');
        }
      } catch (error) {
        showToast("Something went wrong", "error");
        console.error("Error saving user data:", error);
      }
    } else {
      showToast("No Transaction Done", "error");
    }
  };
  return (
    <div>
      <div className="text-[20px] leading-[26px] font-bold text-text-color-1 hidden sm:flex mt-[67px] md:mt-[50px]">
        Choose Benefits
      </div>
      <div className="grid xl:grid-cols-3 lg:grid-cols-2 grid-cols-3 gap-4 mt-[24px]">
        {arr?.map((item: any) => {
          return (
            <div
              key={item?.id}
              className="relative bg-white rounded-[16px] lg:p-[24px] p-[10px] flex lg:flex-row flex-col justify-center lg:justify-start text-center border-[1px] lg:border-[0px] border-bg-color-1 sm:border-bg-color-10 items-center text-[12px] leading-[16px] lg:text-[16px] lg:leading-[20px] font-semibold cursor-pointer"
              onClick={isdisabled ? undefined : handleClick}
              style={{ opacity: isdisabled ? 0.5 : 1, cursor: isdisabled ? "not-allowed" : "pointer" }}
            >
            { isdisabled && <div className="absolute top-0 -right-[5px]">
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                  <rect width="16.4706" height="16.4706" rx="8.23529" fill="transparent" />
                  <path d="M13.3824 5.14706H11.3235V3.60294C11.3235 2.78389 10.9982 1.99839 10.419 1.41923C9.83986 0.840072 9.05436 0.514706 8.23531 0.514706C7.41626 0.514706 6.63075 0.840072 6.0516 1.41923C5.47244 1.99839 5.14707 2.78389 5.14707 3.60294V5.14706H3.08825C2.81523 5.14706 2.5534 5.25551 2.36035 5.44857C2.16729 5.64162 2.05884 5.90345 2.05884 6.17647V13.3824C2.05884 13.6554 2.16729 13.9172 2.36035 14.1103C2.5534 14.3033 2.81523 14.4118 3.08825 14.4118H13.3824C13.6554 14.4118 13.9172 14.3033 14.1103 14.1103C14.3033 13.9172 14.4118 13.6554 14.4118 13.3824V6.17647C14.4118 5.90345 14.3033 5.64162 14.1103 5.44857C13.9172 5.25551 13.6554 5.14706 13.3824 5.14706ZM8.75001 10.206V11.8382C8.75001 11.9747 8.69579 12.1057 8.59926 12.2022C8.50273 12.2987 8.37182 12.3529 8.23531 12.3529C8.0988 12.3529 7.96788 12.2987 7.87136 12.2022C7.77483 12.1057 7.7206 11.9747 7.7206 11.8382V10.206C7.37718 10.0846 7.08774 9.84564 6.90344 9.53146C6.71913 9.21728 6.65183 8.84806 6.71343 8.48905C6.77502 8.13005 6.96155 7.80437 7.24004 7.5696C7.51853 7.33482 7.87106 7.20605 8.23531 7.20605C8.59956 7.20605 8.95208 7.33482 9.23057 7.5696C9.50907 7.80437 9.69559 8.13005 9.75719 8.48905C9.81878 8.84806 9.75148 9.21728 9.56718 9.53146C9.38287 9.84564 9.09343 10.0846 8.75001 10.206ZM10.2941 5.14706H6.17648V3.60294C6.17648 3.05691 6.3934 2.53324 6.7795 2.14713C7.1656 1.76103 7.68927 1.54412 8.23531 1.54412C8.78134 1.54412 9.30501 1.76103 9.69112 2.14713C10.0772 2.53324 10.2941 3.05691 10.2941 3.60294V5.14706Z" fill="#B9BABB" />
                </svg>
              </div>}
              <img
                src={item?.img}
                alt={`${item?.img}`}
                className={`mb-[12px] lg:mb-[0] lg:mr-[8px] ${isdisabled ? 'grayscale' : ''}`}
              />
              {item?.name}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ChooseBenefits;
